<template>
  <div>
    <talent-left-menu/>

    <router-view></router-view>
  </div>
</template>
<script>
  import TalentLeftMenu from './TalentLeftMenu';
  export default {
    name: 'ecommerce-layout',
    components: {
      TalentLeftMenu
    }
  }
</script>
<style>
</style>
